import { Injectable } from '@angular/core';
import { BillingService, WholesalePricingService } from '@galaxy/billing';
import {
  CUSTOM_SUBSCRIPTION_ID,
  ENTERPRISE_SUBSCRIPTION_ID,
  FREE_SUBSCRIPTION_ID,
  SubscriptionTierInterface,
  SubscriptionTiersService,
  VBP2022_CUSTOM_SUBSCRIPTION_ID,
  VBP2022_VERSION,
  VBP2023_VERSION,
  VBP_ENTERPRISE_PILOT_SUBSCRIPTION_ID,
  VBP_ENTERPRISE_SUBSCRIPTION_ID,
} from '@galaxy/partner';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';
import { ManageSubscriptionsService, TierInfo } from '../subscription-tier/utils/manage-subscriptions.service';

const EnterpriseSubscriptionIDs = [
  ENTERPRISE_SUBSCRIPTION_ID,
  VBP_ENTERPRISE_SUBSCRIPTION_ID,
  VBP_ENTERPRISE_PILOT_SUBSCRIPTION_ID,
  CUSTOM_SUBSCRIPTION_ID,
  VBP2022_CUSTOM_SUBSCRIPTION_ID,
];

@Injectable({
  providedIn: 'root',
})
export class UpgradeSubscriptionTierService {
  partnerId: string;
  tiers$: Observable<TierInfo[]>;
  freeTier$: Observable<TierInfo[]>;

  constructor(
    private subscriptionTiersService: SubscriptionTiersService,
    private appConfigService: AppConfigService,
    private billingService: BillingService,
    private wholesalePricingService: WholesalePricingService,
    private manageSubscriptionsService: ManageSubscriptionsService,
  ) {
    this.partnerId = this.appConfigService.config.partnerId;

    this.tiers$ = this.manageSubscriptionsService.tiers$;
    this.freeTier$ = this.manageSubscriptionsService.freeTier$;
  }

  isActiveSubscription(tier$: Observable<SubscriptionTierInterface>): Observable<boolean> {
    return tier$.pipe(
      map((currentTier) => {
        return (
          ((currentTier.tierVersion === VBP2022_VERSION || currentTier.tierVersion === VBP2023_VERSION) &&
            currentTier.allowSelfUpgrade) ||
          currentTier.id === FREE_SUBSCRIPTION_ID ||
          EnterpriseSubscriptionIDs.indexOf(currentTier.id) > -1
        );
      }),
      catchError(() => of(false)),
    );
  }
}
